{
  "labels": {
    "signUp": "",
    "signIn": "",
    "paste": "Incolla",
    "pasteAsPlaintext": "Incolla come testo normale",
    "pasteCharts": "Incolla grafici",
    "chartType_bar": "Grafico a barre",
    "chartType_line": "Grafico a linee",
    "chartType_radar": "Grafico radar",
    "chartType_plaintext": "Testo semplice",
    "selectAll": "Seleziona tutto",
    "multiSelect": "Aggiungi elemento alla selezione",
    "moveCanvas": "Sposta tela",
    "cut": "Taglia",
    "copy": "Copia",
    "copyAsPng": "Copia negli appunti come PNG",
    "copyAsSvg": "Copia negli appunti come SVG",
    "copyText": "Copia negli appunti come testo",
    "copySource": "Copia sorgente negli appunti",
    "convertToCode": "Converti in codice",
    "bringForward": "Porta avanti",
    "sendToBack": "Manda in fondo",
    "bringToFront": "Porta in cima",
    "sendBackward": "Manda dietro",
    "delete": "Elimina",
    "copyStyles": "Copia stili",
    "pasteStyles": "Incolla stili",
    "stroke": "Tratto",
    "changeStroke": "Cambia il colore del tratto",
    "background": "Sfondo",
    "changeBackground": "Cambia il colore dello sfondo",
    "fill": "Riempimento",
    "strokeWidth": "Spessore del tratto",
    "strokeStyle": "Stile del tratto",
    "strokeStyle_solid": "Pieno",
    "strokeStyle_dashed": "Tratteggiato",
    "strokeStyle_dotted": "Punteggiato",
    "sloppiness": "Imprecisione",
    "pressure": "Pressione",
    "pressure_constant": "Costante",
    "pressure_variable": "Variabile",
    "opacity": "Opacità",
    "textAlign": "Allineamento del testo",
    "edges": "Bordi",
    "sharp": "Acuto",
    "round": "Rotondo",
    "arrowheads": "Punta della freccia",
    "arrowhead_none": "Nessuno",
    "arrowhead_arrow": "Freccia",
    "arrowhead_bar": "Barra",
    "arrowhead_circle": "Cerchio",
    "arrowhead_circle_outline": "Cerchio (contorno)",
    "arrowhead_triangle": "Triangolo",
    "arrowhead_triangle_outline": "Triangolo (contorno)",
    "arrowhead_diamond": "Diamante",
    "arrowhead_diamond_outline": "Diamante (contorno)",
    "arrowhead_crowfoot_many": "Zampe di gallina (molti)",
    "arrowhead_crowfoot_one": "Zampa di gallina (una)",
    "arrowhead_crowfoot_one_or_many": "Zampe di gallina (una o molte)",
    "arrowhead_cardinality_one": "Cardinalità (uno)",
    "arrowhead_cardinality_many": "Cardinalità (molti)",
    "arrowhead_cardinality_one_or_many": "Cardinalità (una o molte)",
    "arrowhead_cardinality_exactly_one": "Cardinalità (esattamente una)",
    "arrowhead_cardinality_zero_or_one": "Cardinalità (zero o una)",
    "arrowhead_cardinality_zero_or_many": "Cardinalità (zero o molte)",
    "more_options": "Altre opzioni",
    "cardinality": "Cardinalità",
    "arrowtypes": "Tipo di freccia",
    "arrowtype_sharp": "Freccia affilata",
    "arrowtype_round": "Freccia curva",
    "arrowtype_elbowed": "Freccia a gomito",
    "fontSize": "Dimensione carattere",
    "fontFamily": "Carattere",
    "addWatermark": "Aggiungi \"Creato con Excalidraw\"",
    "handDrawn": "A mano libera",
    "normal": "Normale",
    "code": "Codice",
    "small": "Piccolo",
    "medium": "Medio",
    "large": "Grande",
    "veryLarge": "Molto grande",
    "solid": "Pieno",
    "hachure": "Tratteggio obliquo",
    "zigzag": "Zig zag",
    "crossHatch": "Tratteggio incrociato",
    "thin": "Sottile",
    "bold": "Grassetto",
    "left": "Sinistra",
    "center": "Centro",
    "right": "Destra",
    "extraBold": "Extra Grassetto",
    "architect": "Architetto",
    "artist": "Artista",
    "cartoonist": "Fumettista",
    "fileTitle": "Nome del file",
    "colorPicker": "Selettore colore",
    "canvasColors": "Usato su tela",
    "canvasBackground": "Sfondo tela",
    "drawingCanvas": "Area di disegno",
    "clearCanvas": "Pulisci area di disegno",
    "layers": "Livelli",
    "actions": "Azioni",
    "language": "Lingua",
    "liveCollaboration": "Collaborazione dal vivo...",
    "duplicateSelection": "Duplica",
    "untitled": "Senza titolo",
    "name": "Nome",
    "yourName": "Il vostro nome",
    "madeWithExcalidraw": "Creato con Excalidraw",
    "group": "Crea gruppo da selezione",
    "ungroup": "Dividi gruppo da selezione",
    "collaborators": "Collaboratori",
    "you": "Tu",
    "toggleGrid": "Attiva/disattiva griglia",
    "loadingScene": "Caricamento della scena…",
    "loadScene": "Carica scena da file",
    "align": "Allinea",
    "alignTop": "Allinea in alto",
    "alignBottom": "Allinea in basso",
    "alignLeft": "Allinea a sinistra",
    "alignRight": "Allinea a destra",
    "centerVertically": "Centra Verticalmente",
    "centerHorizontally": "Centra orizzontalmente",
    "distributeHorizontally": "Distribuisci orizzontalmente",
    "distributeVertically": "Distribuisci verticalmente",
    "flipHorizontal": "Capovolgi orizzontalmente",
    "flipVertical": "Capovolgi verticalmente",
    "viewMode": "Modalità visualizzazione",
    "share": "Condividi",
    "showStroke": "Mostra selettore colore del tratto",
    "showBackground": "Mostra selettore colore di sfondo",
    "showFonts": "Mostra selettore font",
    "toggleTheme": "Attiva/Disattiva tema chiaro/scuro",
    "theme": "Tema",
    "decreaseFontSize": "Riduci dimensione dei caratteri",
    "increaseFontSize": "Aumenta la dimensione dei caratteri",
    "unbindText": "Scollega testo",
    "bindText": "Associa il testo al container",
    "createContainerFromText": "Avvolgi il testo in un container",
    "link": {
      "edit": "Modifica link",
      "editEmbed": "Modifica link incorporabile",
      "create": "Aggiungi link",
      "label": "Link",
      "labelEmbed": "Collega & incorpora",
      "empty": "Nessun collegamento impostato",
      "hint": "Digita o incolla qui il tuo link",
      "goToElement": "Vai all'elemento di destinazione"
    },
    "lineEditor": {
      "edit": "Modifica linea",
      "editArrow": "Modifica freccia"
    },
    "polygon": {
      "breakPolygon": "Interrompi poligono",
      "convertToPolygon": "Converti in poligono"
    },
    "elementLock": {
      "lock": "Blocca",
      "unlock": "Sblocca",
      "lockAll": "Blocca tutto",
      "unlockAll": "Sblocca tutto"
    },
    "sidebarLock": "Mantieni aperta la barra laterale",
    "selectAllElementsInFrame": "Seleziona tutti gli elementi nel riquadro",
    "removeAllElementsFromFrame": "Rimuovi tutti gli elementi dal riquadro",
    "eyeDropper": "Scegli il colore della tela",
    "followUs": "Seguici",
    "discordChat": "Chat di Discord",
    "zoomToFitViewport": "Ingrandisci per adattarsi alla vista",
    "zoomToFitSelection": "Ingrandisci per adattare la selezione",
    "zoomToFit": "Zoom per adattare tutti gli elementi",
    "installPWA": "Installa Excalidraw localmente (PWA)",
    "autoResize": "Abilita ridimensionamento automatico del testo",
    "imageCropping": "Ritaglio immagine",
    "unCroppedDimension": "Dimensione non ritagliata",
    "copyElementLink": "Copia il link all'oggetto",
    "linkToElement": "Link all'oggetto",
    "wrapSelectionInFrame": "Avvolgi la selezione nella cornice",
    "tab": "Scheda",
    "shapeSwitch": "Cambia forma",
    "preferences": "Preferenze",
    "preferences_toolLock": "Blocco strumento",
    "boxSelectionMode": "Seleziona su",
    "boxSelectionContain": "Avvolgi",
    "boxSelectionOverlap": "Sovrapponi",
    "arrowBinding": "Legatura a freccia",
    "midpointSnapping": "Aggancia ai punti medi"
  },
  "elementLink": {
    "title": "Link all'oggetto",
    "desc": "Fare clic su una forma su tela o incollare un link.",
    "notFound": "L'oggetto collegato non è stato trovato sulla tela."
  },
  "search": {
    "title": "Trova sulla tela",
    "noMatch": "Non è stato trovato nessun risultato...",
    "singleResult": "risultato",
    "multipleResults": "risultati",
    "placeholder": "Trova testo sulla tela...",
    "frames": "Fotogrammi",
    "texts": "Testi"
  },
  "buttons": {
    "clearReset": "Svuota la tela",
    "exportJSON": "Esporta su file",
    "exportImage": "Esporta immagine...",
    "export": "Salva in...",
    "copyToClipboard": "Copia negli appunti",
    "copyLink": "Copia link",
    "save": "Salva sul file corrente",
    "saveAs": "Salva con nome",
    "load": "Apri",
    "getShareableLink": "Ottieni link condivisibile",
    "close": "Chiudi",
    "selectLanguage": "Seleziona lingua",
    "scrollBackToContent": "Scorri indietro fino al contenuto",
    "zoomIn": "Aumenta ingrandimento",
    "zoomOut": "Riduci ingrandimento",
    "resetZoom": "Ripristina ingrandimento",
    "menu": "Menù",
    "done": "Fatto",
    "edit": "Modifica",
    "undo": "Annulla",
    "redo": "Ripeti",
    "createNewRoom": "Crea nuova stanza",
    "fullScreen": "Schermo intero",
    "darkMode": "Tema scuro",
    "lightMode": "Tema chiaro",
    "systemMode": "Modalità del sistema",
    "zenMode": "Modalità Zen",
    "objectsSnapMode": "Aggancia agli oggetti",
    "exitZenMode": "Uscire dalla modalità zen",
    "cancel": "Annulla",
    "clear": "Cancella",
    "remove": "Rimuovi",
    "embed": "Attiva/disattiva incorporamento",
    "submit": "Invia",
    "confirm": "Conferma",
    "embeddableInteractionButton": "Clicca per interagire"
  },
  "alerts": {
    "clearReset": "Questa azione cancellerà l'intera tela. Sei sicuro?",
    "couldNotCreateShareableLink": "Non riesco a creare un link condivisibile.",
    "couldNotCreateShareableLinkTooBig": "Impossibile creare il link condivisibile: la scena è troppo grande",
    "couldNotLoadInvalidFile": "Impossibile caricare un file no valido",
    "importBackendFailed": "Importazione dal server fallita.",
    "cannotExportEmptyCanvas": "Non è possibile esportare una tela vuota.",
    "couldNotCopyToClipboard": "Impossibile copiare negli appunti.",
    "decryptFailed": "Impossibile decriptare i dati.",
    "uploadedSecurly": "L'upload è stato protetto con la crittografia end-to-end, il che significa che il server Excalidraw e terze parti non possono leggere il contenuto.",
    "loadSceneOverridePrompt": "Se carichi questo disegno esterno, sostituirà quello che hai. Vuoi continuare?",
    "collabStopOverridePrompt": "Interrompere la sessione sovrascriverà il precedente disegno memorizzato localmente. Sei sicuro?\n\n(Se vuoi mantenere il tuo disegno locale, chiudi semplicemente la scheda del browser.)",
    "imageDoesNotContainScene": "Questa immagine pare non contenere alcuna scena. Avevi incluso la scena durante l'esportazione?",
    "cannotRestoreFromImage": "Impossibile ripristinare la scena da questo file immagine",
    "invalidSceneUrl": "Impossibile importare la scena dall'URL fornito. Potrebbe essere malformato o non contenere dati JSON Excalidraw validi.",
    "invalidEncryptionKey": "La chiave di cifratura deve essere composta da 22 caratteri. La collaborazione live è disabilitata.",
    "collabOfflineWarning": "Nessuna connessione internet disponibile.\nLe tue modifiche non verranno salvate!",
    "localStorageQuotaExceeded": "Quota di archiviazione del browser superata. Le modifiche non verranno salvate."
  },
  "errors": {
    "unsupportedFileType": "Tipo di file non supportato.",
    "imageInsertError": "Non è stato possibile inserire l'immagine. Riprova più tardi...",
    "fileTooBig": "Il file è troppo grande. La dimensione massima consentita è {{maxSize}}.",
    "svgImageInsertError": "Impossibile inserire l'immagine SVG. Il markup SVG non sembra corretto.",
    "failedToFetchImage": "Impossibile recuperare l'immagine.",
    "cannotResolveCollabServer": "Impossibile connettersi al server di collab. Ricarica la pagina e riprova.",
    "collabSaveFailed": "Impossibile salvare nel database di backend. Se i problemi persistono, dovresti salvare il tuo file localmente per assicurarti di non perdere il tuo lavoro.",
    "collabSaveFailed_sizeExceeded": "Impossibile salvare nel database di backend, la tela sembra essere troppo grande. Dovresti salvare il file localmente per assicurarti di non perdere il tuo lavoro.",
    "imageToolNotSupported": "Le immagini sono disabilitate.",
    "brave_measure_text_error": {
      "line1": "Sembra che tu stia utilizzando il browser Brave con l'impostazione <bold>Blocco aggressivo delle impronte digitali</bold> abilitata.",
      "line2": "Ciò potrebbe causare la rottura degli <bold>Elementi di testo</bold> nei tuoi disegni.",
      "line3": "Consigliamo vivamente di disabilitare questa impostazione. Puoi seguire <link>questi passaggi</link> su come farlo.",
      "line4": "Se la disattivazione di questa impostazione non risolve la visualizzazione degli elementi di testo, apri un <issueLink>problema</issueLink> sul nostro GitHub o scrivici su <discordLink>Discord</discordLink>"
    },
    "asyncPasteFailedOnRead": "Impossibile incollare (non è possibile leggere dagli appunti di sistema).",
    "asyncPasteFailedOnParse": "Impossibile incollare.",
    "copyToSystemClipboardFailed": "Impossibile copiare negli appunti."
  },
  "toolBar": {
    "selection": "Selezione",
    "lasso": "Selezione a lazo",
    "image": "Inserisci immagine",
    "rectangle": "Rettangolo",
    "diamond": "Rombo",
    "ellipse": "Ellisse",
    "arrow": "Freccia",
    "line": "Linea",
    "freedraw": "Disegno",
    "text": "Testo",
    "lock": "Mantieni lo strumento selezionato attivo dopo aver disegnato",
    "penMode": "Modalità penna - previene il tocco",
    "link": "Aggiungi / aggiorna collegamento per una forma selezionata",
    "eraser": "Gomma",
    "frame": "Strumento riquadro",
    "embeddable": "Incorporamento Web",
    "laser": "Puntatore laser",
    "autoshape": "Disegna per la forma",
    "bucketfill": "Secchiello riempimento",
    "hand": "Mano (strumento di panoramica)",
    "extraTools": "Altri strumenti",
    "convertElementType": "Attiva tipo di forma"
  },
  "bucketfill": {
    "noRegion": "Impossibile trovare una regione racchiusa da riempire qui.",
    "tooComplex": "Questa regione è troppo complessa da riempire."
  },
  "element": {
    "rectangle": "Rettangolo",
    "diamond": "Diamante",
    "ellipse": "Ellisse",
    "arrow": "Freccia",
    "line": "Linea",
    "freedraw": "Disegno libero",
    "text": "Testo",
    "image": "Immagine",
    "group": "Gruppo",
    "frame": "Cornice",
    "embeddable": "Incorporamento Web",
    "selection": "Selezione",
    "iframe": "IFrame"
  },
  "headings": {
    "canvasActions": "Azioni sulla Tela",
    "selectedShapeActions": "Impostazioni della forma selezionata",
    "shapes": "Forme"
  },
  "hints": {
    "dismissSearch": "{{shortcut}} per ignorare la ricerca",
    "canvasPanning": "Per spostare la tela, tieni premuto {{shortcut_1}} o {{shortcut_2}} durante il trascinamento, oppure usa lo strumento della mano",
    "linearElement": "Clicca per iniziare una linea in più punti, trascina per singola linea",
    "arrowTool": "Fai clic per iniziare più punti, trascina per una singola linea. Premi di nuovo {{shortcut}} per cambiare il tipo di freccia.",
    "arrowBindModifiers": "Tieni premuto {{shortcut_1}} per disabilitare il binding, oppure {{shortcut_2}} per il binding a un punto fisso",
    "freeDraw": "Clicca e trascina, rilascia quando avrai finito",
    "text": "Suggerimento: puoi anche aggiungere del testo facendo doppio clic ovunque con lo strumento di selezione",
    "embeddable": "Fare click e trascina per creare un incorporamento web",
    "autoshape": "Disegna rettangoli, cerchi, diamanti, linee e frecce",
    "text_selected": "Fare doppio clic o premere {{shortcut}} per modificare il testo",
    "text_editing": "Premi {{shortcut_1}} o {{shortcut_2}} per terminare la modifica",
    "linearElementMulti": "Clicca sull'ultimo punto o premi {{shortcut_1}} o {{shortcut_2}} per terminare",
    "lockAngle": "Puoi limitare l'angolo tenendo premuto {{shortcut}}",
    "resize": "Puoi limitare le proporzioni tenendo premuto {{shortcut_1}} durante il ridimensionamento,\ntenendo premuto {{shortcut_2}} per ridimensionare dal centro",
    "resizeImage": "Puoi ridimensionare liberamente tenendo premuto {{shortcut_1}},\ntenendo premuto {{shortcut_2}} per ridimensionare dal centro",
    "rotate": "Puoi limitare gli angoli tenendo premuto {{shortcut}} durante la rotazione",
    "toggleArrowhead": "Doppio clic per attivare o disattivare la freccia",
    "lineEditor_info": "Tieni premuto {{shortcut_1}} e fai doppio clic oppure premi {{shortcut_2}} per modificare i punti",
    "lineEditor_line_info": "Fare doppio clic o premere {{shortcut}} per modificare i punti",
    "lineEditor_pointSelected": "Premi {{shortcut_1}} per rimuovere punto(i),\n{{shortcut_2}} per duplicare, o trascinare per spostare",
    "lineEditor_nothingSelected": "Seleziona un punto da modificare (tieni premuto {{shortcut_1}} per selezionarne più di uno),\noppure tieni premuto {{shortcut_2}} e fai clic per aggiungere nuovi punti",
    "bindTextToElement": "{{shortcut}} per aggiungere testo",
    "createFlowchart": "{{shortcut}} per creare un diagramma di flusso",
    "deepBoxSelect": "Tieni premuto {{shortcut}} per selezionare in profondità e per evitare il trascinamento",
    "eraserRevert": "Tieni premuto {{shortcut}} per ripristinare gli elementi contrassegnati per l'eliminazione",
    "firefox_clipboard_write": "Questa funzione può essere abilitata impostando il flag \"dom.events.asyncClipboard.clipboardItem\" su \"true\". Per modificare i flag del browser in Firefox, visitare la pagina \"about:config\".",
    "disableSnapping": "Tieni premuto {{shortcut}} per disattivare lo snap",
    "enterCropEditor": "Fare doppio clic sull'immagine o premere {{shortcut}} per ritagliare l'immagine",
    "leaveCropEditor": "Fare clic all'esterno dell'immagine o premere {{shortcut_1}} o {{shortcut_2}} per terminare il ritaglio"
  },
  "canvasError": {
    "cannotShowPreview": "Impossibile visualizzare l'anteprima",
    "canvasTooBig": "La tela potrebbe essere troppo grande.",
    "canvasTooBigTip": "Suggerimento: prova a spostare gli elementi più lontani più vicini tra loro."
  },
  "errorSplash": {
    "headingMain": "Si è verificato un errore. Provare <button>ricaricando la pagina.</button>",
    "clearCanvasMessage": "Se ricaricare non funziona, prova <button>pulire la tela.</button>",
    "clearCanvasCaveat": " Questo risulterà nella perdita del lavoro ",
    "trackedToSentry": "L'errore con identificativo {{eventId}} è stato tracciato nel nostro sistema.",
    "openIssueMessage": "Siamo stati molto cauti nel non includere informazioni della scena nell'errore. Se la tua scena non è privata, ti preghiamo di considerare la sua inclusione nel nostro <button>bug tracker.</button> Per favore includi le informazioni riportate qui sotto copiandole e incollandole nella issue di GitHub.",
    "sceneContent": "Contenuto della scena:"
  },
  "shareDialog": {
    "or": "O"
  },
  "roomDialog": {
    "desc_intro": "Invita altri a collaborare al tuo disegno.",
    "desc_privacy": "Non preoccuparti, la sessione utilizza la crittografia end-to-end ed è completamente privata. Nemmeno il nostro server è in grado di vedere ciò che disegni.",
    "button_startSession": "Avvia sessione",
    "button_stopSession": "Termina sessione",
    "desc_inProgressIntro": "La sessione di collaborazione è attualmente in corso.",
    "desc_shareLink": "Condividi questo link con chiunque desideri collaborare:",
    "desc_exitSession": "Interrompere la sessione scollegherà la tua stanza ma potrai continuare a lavorare con la scena, localmente. Tieni presente che questo non influirà sulle altre persone, e che saranno ancora in grado di collaborare alla loro versione.",
    "shareTitle": "Partecipa a una sessione di collaborazione live su Excalidraw"
  },
  "errorDialog": {
    "title": "Errore"
  },
  "progressDialog": {
    "title": "Salvataggio",
    "defaultMessage": "Preparazione per il salvataggio..."
  },
  "exportDialog": {
    "disk_title": "Salva su disco",
    "disk_details": "Esporta i dati della scena su file, dal quale potrai importare in seguito.",
    "disk_button": "Salva su file",
    "link_title": "Link condivisibile",
    "link_details": "Esporta come link di sola lettura.",
    "link_button": "Esporta come Link",
    "excalidrawplus_description": "Salva la scena nel tuo spazio di lavoro Excalidraw+.",
    "excalidrawplus_button": "Esporta",
    "excalidrawplus_exportError": "Non è stato possibile esportare su Excalidraw+ al questo momento..."
  },
  "helpDialog": {
    "blog": "Leggi il nostro blog",
    "click": "click",
    "deepSelect": "Selezione profonda",
    "deepBoxSelect": "Seleziona in profondità all'interno della casella e previene il trascinamento",
    "createFlowchart": "Crea un diagramma di flusso da un elemento generico",
    "navigateFlowchart": "Naviga un diagramma di flusso",
    "curvedArrow": "Freccia curva",
    "curvedLine": "Linea curva",
    "documentation": "Documentazione",
    "doubleClick": "doppio-click",
    "drag": "trascina",
    "editor": "Editor",
    "editLineArrowPoints": "Modifica punti linea/freccia",
    "editText": "Modifica testo / aggiungi etichetta",
    "github": "Trovato un problema? Segnalalo",
    "howto": "Segui le nostre guide",
    "or": "oppure",
    "preventBinding": "Impedisci legame della freccia",
    "tools": "Stumenti",
    "shortcuts": "Scorciatoie da tastiera",
    "textFinish": "Completa la modifica (editor di testo)",
    "textNewLine": "Aggiungi nuova riga (editor di testo)",
    "title": "Guida",
    "view": "Vista",
    "zoomToFit": "Adatta zoom per mostrare tutti gli elementi",
    "zoomToSelection": "Zoom alla selezione",
    "toggleElementLock": "Blocca/sblocca selezione",
    "movePageUpDown": "Sposta la pagina su/giù",
    "movePageLeftRight": "Sposta la pagina a sinistra/destra",
    "cropStart": "Ritaglia immagine",
    "cropFinish": "Termina ritaglio immagine"
  },
  "clearCanvasDialog": {
    "title": "Svuota la tela"
  },
  "imageExportDialog": {
    "header": "Esporta immagine",
    "label": {
      "withBackground": "Sfondo",
      "onlySelected": "Solo selezionato",
      "darkMode": "Tema scuro",
      "embedScene": "Includi scena",
      "scale": "Scala",
      "padding": "Rientro"
    },
    "tooltip": {
      "embedScene": "I dati della scena saranno salvati nel file PNG/SVG esportato in modo che la scena possa essere ripristinata da esso.\nQuesto aumenterà la dimensione del file esportato."
    },
    "title": {
      "exportToPng": "Esporta come PNG",
      "exportToSvg": "Esporta come SVG",
      "copyPngToClipboard": "Copia PNG negli appunti"
    },
    "button": {
      "exportToPng": "PNG",
      "exportToSvg": "SVG",
      "copyPngToClipboard": "Copia negli appunti"
    }
  },
  "encrypted": {
    "tooltip": "I tuoi disegni sono crittografati end-to-end in modo che i server di Excalidraw non li possano mai vedere.",
    "link": "Articolo del blog sulla crittografia end-to-end di Excalidraw"
  },
  "stats": {
    "angle": "Angolo",
    "shapes": "Forme",
    "height": "Altezza",
    "scene": "Scena",
    "selected": "Selezionato",
    "storage": "Memoria",
    "fullTitle": "Proprietà della tela & forma",
    "title": "Proprietà",
    "generalStats": "Generale",
    "elementProperties": "Proprietà delle forme",
    "total": "Totale",
    "version": "Versione",
    "versionCopy": "Clicca per copiare",
    "versionNotAvailable": "Versione non disponibile",
    "width": "Larghezza"
  },
  "toast": {
    "copyStyles": "Stili copiati.",
    "copyToClipboard": "Copiato negli appunti.",
    "copyToClipboardAsPng": "{{exportSelection}} copiato negli appunti come PNG\n({{exportColorScheme}})",
    "copyToClipboardAsSvg": "Copiato {{exportSelection}} negli appunti come SVG\n({{exportColorScheme}})",
    "fileSaved": "File salvato.",
    "fileSavedToFilename": "Salvato in {filename}",
    "canvas": "tela",
    "selection": "selezione",
    "pasteAsSingleElement": "Usa {{shortcut}} per incollare come un singolo elemento,\no incollare in un editor di testo esistente",
    "unableToEmbed": "Incorporare questo url non è permesso. Crea una issue su GitHub per richiedere che l'url sia autorizzato",
    "unrecognizedLinkFormat": "Il link che hai incorporato non corrisponde al formato previsto. Prova a incollare la stringa 'embed' fornita dal sito di origine",
    "elementLinkCopied": "Link copiato negli appunti"
  },
  "colors": {
    "transparent": "Trasparente",
    "black": "Nero",
    "white": "Bianco",
    "red": "Rosso",
    "pink": "Rosa",
    "grape": "Uva",
    "violet": "Viola",
    "gray": "Grigio",
    "blue": "Blu",
    "cyan": "Ciano",
    "teal": "Verde acqua",
    "green": "Verde",
    "yellow": "Giallo",
    "orange": "Arancio",
    "bronze": "Bronzo"
  },
  "welcomeScreen": {
    "app": {
      "center_heading": "I tuoi disegni vengono salvati nella memoria del tuo browser.",
      "center_heading_line2": "La memoria del browser potrebbe essere cancellata inaspettatamente.",
      "center_heading_line3": "Salva regolarmente il tuo lavoro in un file per evitare di perderlo.",
      "center_heading_plus": "Volevi invece andare su Excalidraw+?",
      "menuHint": "Esporta, preferenze, lingue, ..."
    },
    "defaults": {
      "menuHint": "Esporta, preferenze, e altro...",
      "center_heading": "Diagrammi. Fatto. Semplice.",
      "toolbarHint": "Scegli uno strumento & Inizia a disegnare!",
      "helpHint": "Scorciatoie & aiuto"
    }
  },
  "colorPicker": {
    "color": "Colore",
    "mostUsedCustomColors": "Colori personalizzati più utilizzati",
    "colors": "Colori",
    "shades": "Sfumature",
    "hexCode": "Codice esadecimale",
    "noShades": "Nessuna sfumatura disponibile per questo colore",
    "invalidColor": "Colore non valido",
    "invalidHexLength": "Il codice esadecimale deve essere di 3, 4, 6 o 8 caratteri",
    "topPicksTip": "Suggerimento: trascina qualsiasi colore sulle tue selezioni superiori per bloccarlo",
    "resetTopPicks": "Ripristina le selezioni superiori predefinite"
  },
  "overwriteConfirm": {
    "action": {
      "exportToImage": {
        "title": "Esporta come immagine",
        "button": "Esporta come immagine",
        "description": "Esporta i dati della scena come immagine, che potrai importare in seguito."
      },
      "saveToDisk": {
        "title": "Salva su disco",
        "button": "Salva su disco",
        "description": "Esporta i dati della scena su file, che potrai importare in seguito."
      },
      "excalidrawPlus": {
        "title": "Excalidraw+",
        "button": "Esporta su Excalidraw+",
        "description": "Salva la scena sul tuo spazio di lavoro Excalidraw+."
      }
    },
    "modal": {
      "loadFromFile": {
        "title": "Carica da file",
        "button": "Carica da file",
        "description": "Il caricamento da file sostituirà <bold>il contenuto esistente</bold>.<br></br>Puoi salvare il tuo disegno prima usando una delle opzioni qui sotto."
      },
      "shareableLink": {
        "title": "Carica da link",
        "button": "Sostituisci il mio contenuto",
        "description": "Il caricamento da file sostituirà <bold>il contenuto esistente</bold>.<br></br>Puoi salvare il tuo disegno prima usando una delle opzioni qui sotto."
      }
    }
  },
  "quickSearch": {
    "placeholder": "Ricerca rapida"
  },
  "fontList": {
    "badge": {
      "old": "vecchio"
    },
    "sceneFonts": "In questa scena",
    "availableFonts": "Font disponibili",
    "empty": "Nessun font trovato"
  },
  "userList": {
    "empty": "Nessun utente trovato",
    "hint": {
      "text": "Clicca sull'utente per seguirlo",
      "followStatus": "Stai attualmente seguendo questo utente",
      "inCall": "Utente è in una chiamata vocale",
      "micMuted": "Il microfono dell'utente è disattivato",
      "isSpeaking": "L'utente sta parlando"
    }
  },
  "keys": {
    "ctrl": "Ctrl",
    "option": "Opzione",
    "cmd": "Cmd",
    "alt": "Alt",
    "escape": "Esc",
    "enter": "Invio",
    "shift": "Shift",
    "spacebar": "Spazio",
    "delete": "Elimina",
    "mmb": "Rotella di scorrimento"
  }
}
